import { call, put, takeLatest } from 'redux-saga/effects';

import * as url from '../../helpers/url_helper';
import { bookingsListTypes } from './actionTypes';
import {
    getBookingsListSuccess,
    getBookingsListFail,
    getMilestoneConfigBKSuccess,
    getMilestoneConfigBKFail,
} from './actions';
import { getMilestoneConfigOperation } from '../../helpers/GetMilestoneConfigOperation';

let controller = new AbortController();
let signal = controller.signal;

export const cancelFetchBK = () => {
    controller.abort();
    controller = new AbortController();
    signal = controller.signal;
};

export const fetchBookingsList = async (data: any) => {
    const { from, to, order, dynamicFilter, dynamicFilterCF } = data.form;
    const { sizePerPage, page } = data.pagination;

    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `query {
    GetBookingList(Booking: {
      userId: ${user.id || ''},
      initial_date: "${from || ''}",
      final_date: "${to + ' 11:59:00' || ''}",
      order: "${order}",
      ${dynamicFilterCF}
      ${dynamicFilter}
    }, Pagination: {
      sizePage: ${sizePerPage},
      actualPage: ${page}
    }) {
      CountItems
      BookingData {
        id
        clientId
        GUID
        Number
        URL
        CreatedOn
        CreatedByName
        Version
        ModeOfTransportCode
        ModeOfTransportDescription
        IssuedByName
        IssuedByGUID
        ShipperName
        ShipperGUID
        ConsigneeName
        ConsigneeGUID
        ImporterName
        ImporterGUID
        BillingClientName
        BillingClientGUID
        DeliverToEntityName
        DeliverToEntityGUID
        OriginPortCode
        OriginPortName
        OriginCountryCode
        DestinationPortCode
        DestinationPortName
        DestinationCountryCode
        Direction
        Service
        BookingStatus
        IsLessThanFullLoad
        IsOnlineBooking
        IsOnline
        IsLiquidated
        ExecutedPlace
        CustomerReferenceNumber
        EstimatedArrivalDate
        EstimatedDepartureDate
        LastDateOfDeparture
        SpottingDate
        PickupDate
        CutoffDate
        TotalPieces
        ChargeableWeight
        TotalWeight
        TotalVolume
        TotalVolumeWeight
        TotalValue
        WeightUnit
        VolumeUnit
        VolumeWeightUnit
        CurrencyCode
        CreatorNetworkID
        HasFiles
      }
    }
  }`;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        signal,
        body: JSON.stringify({ query }),
    }).then((res) => res.json());

    return response.data.GetBookingList;
};

function* fetchBookingsListSaga(data: any) {
    try {
        const response: Promise<any> = yield call(fetchBookingsList, data.payload);
        yield put(getBookingsListSuccess(response));
    } catch (error) {
        yield put(getBookingsListFail(error));
    }
}

function* getMilestoneConfigBK(data: any): any {
    try {
        const response: Promise<any> = yield call(getMilestoneConfigOperation, {
            OperationType: 'BK',
            ...data?.payload,
        });
        yield put(getMilestoneConfigBKSuccess(response));
    } catch (error) {
        yield put(getMilestoneConfigBKFail(error));
    }
}

function* bookingsListSaga() {
    yield takeLatest(bookingsListTypes.GET_BOOKINGS_LIST, fetchBookingsListSaga);
    yield takeLatest(bookingsListTypes.GET_MILESTONESCONFIG_BK, getMilestoneConfigBK);
}

export default bookingsListSaga;
